// pass url params through CTA buttons
export default function handleCTAClick(event, cta) {
  event.preventDefault();
  let ctaUrl = cta.link ?? '';

  const urlParams = new URLSearchParams(window?.location?.search);
  const queryString = urlParams.toString();

  if (ctaUrl.startsWith('#')) {
    ctaUrl = queryString ? `?${queryString}${ctaUrl}` : ctaUrl;
  } else {
    ctaUrl +=
      ctaUrl.indexOf('?') === -1
        ? `${queryString ? `?${queryString}` : ''}`
        : `${queryString ? `&${queryString}` : ''}`;
  }

  window.location.assign(ctaUrl);
}
